import moment from 'moment';

import {rison} from 'common/util/rison';
import {getReportBaseUrl, propertyFiltersToCohorts, propertyFiltersToSegFilters} from './common';

const TIME_UNIT_MAP = {
  DAY: `day`,
  WEEK: `week`,
  MONTH: `month`,
};

const SEGMENT_METHOD_MAP = {
  FIRST: `single`,
  ALL: `multiple`,
};

const RETENTION_TYPE_MAP = {
  BIRTH: `birth`,
  COMPOUNDED: `compounded`,
};

const exports = {};
export default exports;

/* eslint-disable camelcase */
exports.generateParams = function({query, alertType, alertId, shared}) {
  const urlParams = {};

  urlParams.event = query.event;
  if (query.propertyFilters && query.propertyFilters.length) {
    const filters = propertyFiltersToSegFilters(query.propertyFilters, {isTypecastable: false});
    if (filters.length) {
      urlParams.filters = filters;
    }
    const cohorts = propertyFiltersToCohorts(query.propertyFilters);
    if (cohorts.length) {
      urlParams.cohorts = cohorts;
    }
  }

  if (query.segmentOn) {
    urlParams.on = query.segmentOn;
    urlParams.segmentation_event = query.segmentEvent;
    urlParams.segments = SEGMENT_METHOD_MAP[query.segmentMethod];
  }

  urlParams.percentage_view = query.countType === `PERCENT`;

  urlParams.retention_type = RETENTION_TYPE_MAP[query.retentionType];
  if (query.bornEvent) {
    urlParams.born_event = query.bornEvent;
    if (query.bornPropertyFilters && query.bornPropertyFilters.length) {
      const born_filters = propertyFiltersToSegFilters(query.bornPropertyFilters, {isTypecastable: false});
      if (born_filters.length) {
        urlParams.born_filters = born_filters;
      }
    }
  }

  // TODO(mack): Figure out how to handle timezones
  const currMoment = moment();
  urlParams.date_range = {
    from: moment(query.dateRange.from).diff(currMoment, `days`),
    to: moment(query.dateRange.to).diff(currMoment, `days`),
  };
  urlParams.date_unit = TIME_UNIT_MAP[query.timeUnit];

  urlParams.smart_hub = {alert_type: alertType, alert_id: alertId}; // eslint-disable-line camelcase

  if (shared) {
    urlParams.shared = `smarthub`;
  }

  return urlParams;
};
/* eslint-enable camelcase */

// See RetentionQuery in clj/service/smart-hub/protos/smart_hub.proto for the query format
exports.generatePermalink = function({query, alertType, alertId, projectId, shared, workspaceId}, absolute = false) {
  const urlParams = exports.generateParams({
    query,
    alertType,
    alertId,
    shared,
  });
  const urlHash = rison.urlencode(urlParams);
  let link = `${getReportBaseUrl({
    projectId,
    workspaceId,
  })}/retention/#${urlHash.substring(1, urlHash.length - 1)}`;
  if (absolute) {
    const rootURL = `${window.location.protocol}//${window.location.host}`;
    link = rootURL + link;
  }
  return link;
};
